import { makeGetApiObjectState } from 'uf/api/selectors';
import { makeLayerBoundsKey } from 'uf/layers/bounds';

export function makeGetLayerBounds() {
  return makeGetApiObjectState('layer', 'get_layer_bounds', makeLayerBoundsKey);
}
